/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AssistantChatRequestCurrentFilters } from './assistantChatRequestCurrentFilters';
import type { AssistantMessageSchema } from './assistantMessageSchema';

export interface AssistantChatRequest {
  /** @maxItems 100 */
  messages: AssistantMessageSchema[];
  current_filters?: AssistantChatRequestCurrentFilters;
}
